import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FillOrJoinCandidateComponent } from './fill-or-join-candidate.component';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { ExternalNotesModule } from '../external-notes/external-notes.module';
import { AiAssistantModule } from '../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [FillOrJoinCandidateComponent],
  imports: [
    CommonModule,
    FormsModule,
    PopoverModule,
    PipesModule,
    ExternalNotesModule,
    AiAssistantModule
  ],
  exports: [FillOrJoinCandidateComponent],
  entryComponents: [FillOrJoinCandidateComponent]
})
export class FillOrJoinCandidateModule { }
